import { computed, ref } from 'vue'

/**
 * KeepAlive include 名单（响应式）
 *
 * 设计动机：App.vue 不直接 import stores/app，避免触发 bridge 模块的循环依赖
 * 加载链。该配置由 main.ts 在 store / 设备信息就绪后调用 applyKeepAliveConfig 注入。
 *
 * 默认值：保活已启用（覆盖 H5 与新版 App 大多数场景，低版本 App 在 main.ts 中显式关闭）。
 */
export const keepAliveIncludes = ref<string[]>([
  'BillView',
  'DetailsView',
  'ChatView',
])

/**
 * 是否启用新结构（双行 NavHeader + 3 Tab）
 * 与 keepAliveIncludes 联动：启用保活即启用新结构
 */
export const newHeaderEnabled = ref<boolean>(true)

/**
 * 设置保活与新头部启用状态
 * @param enabled true: 启用；false: 关闭（低版本 App 兜底）
 */
export function applyKeepAliveConfig(enabled: boolean): void {
  keepAliveIncludes.value = enabled
    ? ['BillView', 'DetailsView', 'ChatView']
    : []
  newHeaderEnabled.value = enabled
}

/**
 * App 状态栏高度（px）。
 * - App 环境：main.ts 启动时由 tcGetStatusBarHeight 注入
 * - H5 环境：保持 0，无需让位
 *
 * 同样放在这里以避免组件顶层 import bridge 引发循环依赖。
 */
export const statusBarHeight = ref<number>(0)

/**
 * 注入 App 状态栏高度
 */
export function applyStatusBarHeight(height: number): void {
  if (height > 0) statusBarHeight.value = height
}

/** NavHeader 双行内容高度（不含状态栏让位） */
export const NAV_HEADER_CONTENT_HEIGHT = 184

/** NavHeader 总高度（含状态栏让位），供需要预留头部空间的容器使用 */
export const navHeaderTotalHeight = computed(
  () => NAV_HEADER_CONTENT_HEIGHT + statusBarHeight.value,
)
